export default __webpack_public_path__ + "static/media/whatsapp-logo.6d3020e5.svg";